import modalTemplate from './view.html';
import { UsbAttackDeleteModalController } from './controller';

import { USB_ATTACK_DELETE_MODAL_CONTROLLER } from '../../const';

class UsbAttackDeleteModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    $onInit = () => {
        this.$uibModal;
    };

    open = (attack = null) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: USB_ATTACK_DELETE_MODAL_CONTROLLER,
            controllerAs: '$',
            size: 'nm',
            resolve: {
                attack: attack,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    UsbAttackDeleteModal,
    UsbAttackDeleteModalController,
};
